import { SET_IS_ONLINE, SET_PAGE_HEADER, SET_STC } from "../mutations.type";
import i18n from "@/plugins/i18n";

export const state = {
  pageTitle: "",
  backScreen: "",
  btnBackText: i18n.t("button.back"),
  query: {},
  onClick: null,
  isOnline: true,
  stc: false,
};

export const actions = {};

export const mutations = {
  [SET_PAGE_HEADER](
    state,
    [pageTitle, backScreen, btnBackText, query, onClick],
  ) {
    state.pageTitle = pageTitle;
    if (backScreen) state.backScreen = backScreen;
    if (btnBackText) state.btnBackText = btnBackText;
    state.query = query;
    state.onClick = onClick;
  },
  [SET_IS_ONLINE](state, value) {
    state.isOnline = value;
  },
  [SET_STC](state, value) {
    state.stc = value;
  },
};

const getters = {
  pageTitle(state) {
    return state.pageTitle;
  },
  backScreen(state) {
    return state.backScreen;
  },
  btnBackText(state) {
    return state.btnBackText;
  },
  query(state) {
    return state.query;
  },
  onClick(state) {
    return state.onClick;
  },
  isOnline(state) {
    return state.isOnline;
  },
  stc(state) {
    return state.stc;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
